var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.item.length > 0
    ? _c(
        "section",
        { staticClass: "module dt-like" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.hobby_title))]),
          _vm._v(" "),
          _vm._l(_vm.item, function (value, index) {
            return [
              _c(
                "ul",
                { key: index, staticClass: "dt-detail-like-list" },
                _vm._l(_vm.truncate(value), function (v, i) {
                  return _c("li", { key: i }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: v.url,
                          uigs: "tiny_out_hobby_" + (index * 9 + i) + "_p",
                          title: v.name,
                        },
                      },
                      [
                        _c("div", { staticClass: "dt-detail-like-img" }, [
                          _c(
                            "div",
                            {
                              class: [
                                _vm.spver === 1
                                  ? "default-film"
                                  : "default-sogou",
                              ],
                            },
                            [
                              _vm.isSpider
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.checkHttps(v.v_picurl),
                                      alt: v.name + "剧照",
                                    },
                                  })
                                : _c("img", {
                                    directives: [
                                      {
                                        name: "lazy",
                                        rawName: "v-lazy",
                                        value: _vm.checkHttps(v.v_picurl),
                                        expression: "checkHttps(v.v_picurl)",
                                      },
                                    ],
                                    attrs: { alt: v.name + "剧照" },
                                  }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "tag-mark" }, [
                            _vm._v(_vm._s(v.score)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "dt-like-name" }, [
                          _vm._v(_vm._s(v.name)),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }